/**
 * MUSKLE Productgids variant controller
 * Reacts to selected Shopify variant and swaps verified Productgids PDP + guide card.
 *
 * Locked multi-flavour contract (20260807-210749):
 * - pdp_en_json / pdp_nl_json = safe product-level BASE PDP (optional)
 * - pdp_variant_map_json = verified exact-variant OVERRIDE (+ guide card)
 * - Unverified flavour: keep base PDP visible; hide exact override + guide card
 * - Verified flavour: show exact override groups only (one visible version); show card
 * - Never blank the whole Productinformatie host when a base payload exists
 * - Never leak one flavour's exact ingredients/card to another flavour
 *
 * Card shell parity: CTA card image stays shared muskleproductgids graphic (CARB-X).
 * Stamp: shared-pdp-fallback-20260807-210749
 */
(function () {
  'use strict';
  if (window.MuskleProductgidsVariant) {
    window.MuskleProductgidsVariant.apply();
    return;
  }

  function normalizeVariantId(id) {
    if (id == null) return '';
    var s = String(id).trim();
    if (!s) return '';
    var m = s.match(/(\d{10,})$/);
    return m ? m[1] : s.replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseJson(raw) {
    if (!raw) return null;
    if (typeof raw !== 'string') return raw;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function parseMap(raw) {
    var parsed = parseJson(raw) || {};
    return {
      schema_version: Number(parsed.schema_version) || 1,
      variants: Array.isArray(parsed.variants) ? parsed.variants : []
    };
  }

  function parseBase(raw) {
    var parsed = parseJson(raw);
    if (!parsed) return null;
    if (Array.isArray(parsed.groups)) return parsed;
    return null;
  }

  function indexMap(map) {
    var byId = Object.create(null);
    var parsed = parseMap(map);
    for (var i = 0; i < parsed.variants.length; i++) {
      var entry = parsed.variants[i];
      if (!entry) continue;
      var id = normalizeVariantId(entry.variant_id || entry.variantId);
      if (id) byId[id] = entry;
    }
    return byId;
  }

  function renderGroupsHtml(data, lang) {
    if (!data || !Array.isArray(data.groups)) return '';
    var parts = [];
    for (var gi = 0; gi < data.groups.length; gi++) {
      var group = data.groups[gi];
      if (!group) continue;
      var gtitle = (group.title || '').trim();
      var hasContent =
        gtitle ||
        (group.paragraphs && group.paragraphs.length) ||
        (group.facts && group.facts.length) ||
        group.table ||
        group.html ||
        (group.nutrition_items && group.nutrition_items.length) ||
        (group.alert && group.alert.text);
      if (!hasContent) continue;

      parts.push('<div class="muskle-product-intelligence__group">');
      if (gtitle) {
        parts.push('<h3 class="muskle-product-intelligence__group-title">' + escapeHtml(gtitle) + '</h3>');
      } else {
        parts.push(
          '<h3 class="muskle-product-intelligence__group-title">' +
            (lang === 'en' ? 'Product information' : 'Productinformatie') +
            '</h3>'
        );
      }
      parts.push('<div class="muskle-product-intelligence__content">');

      if (group.paragraphs) {
        for (var pi = 0; pi < group.paragraphs.length; pi++) {
          var p = group.paragraphs[pi];
          if (p) {
            parts.push(
              '<p class="muskle-product-intelligence__description">' + escapeHtml(p) + '</p>'
            );
          }
        }
      }
      if (group.facts && group.facts.length) {
        parts.push('<div class="muskle-product-intelligence__content-raw rte"><ul>');
        for (var fi = 0; fi < group.facts.length; fi++) {
          if (group.facts[fi]) parts.push('<li>' + escapeHtml(group.facts[fi]) + '</li>');
        }
        parts.push('</ul></div>');
      }
      if (group.html) {
        parts.push(
          '<div class="muskle-product-intelligence__content-raw rte muskle-pdp-table-host">' +
            group.html +
            '</div>'
        );
      }
      if (group.table && group.table.headers && group.table.rows) {
        var hdr0 = String(group.table.headers[0] || '').toLowerCase();
        var tableVariant = hdr0 === 'item' || hdr0 === 'onderdeel' ? 'ingredients' : 'composition';
        parts.push(
          '<div class="muskle-guide-table-wrap muskle-product-intelligence__table-wrap mpg-table-wrap pdp-table-wrap" tabindex="0" role="region" aria-label="' +
            escapeHtml(gtitle || 'Product data') +
            '">'
        );
        parts.push(
          '<table class="muskle-guide-table muskle-guide-table--' +
            tableVariant +
            ' muskle-guide-table--compact muskle-product-intelligence__table mpg-table pdp-table"><thead><tr>'
        );
        for (var hi = 0; hi < group.table.headers.length; hi++) {
          parts.push('<th scope="col">' + escapeHtml(group.table.headers[hi]) + '</th>');
        }
        parts.push('</tr></thead><tbody>');
        for (var ri = 0; ri < group.table.rows.length; ri++) {
          var row = group.table.rows[ri] || [];
          parts.push('<tr>');
          for (var ci = 0; ci < row.length; ci++) {
            if (ci === 0) parts.push('<th scope="row">' + escapeHtml(row[ci]) + '</th>');
            else parts.push('<td>' + escapeHtml(row[ci]) + '</td>');
          }
          parts.push('</tr>');
        }
        parts.push('</tbody></table></div>');
      } else if (group.nutrition_items && group.nutrition_items.length) {
        var labelComp = lang === 'nl' ? 'Samenstelling' : 'Composition';
        var h1 = lang === 'nl' ? 'Bestanddeel' : 'Component';
        var h2 = lang === 'nl' ? 'Hoeveelheid' : 'Amount';
        parts.push(
          '<div class="muskle-guide-table-wrap muskle-product-intelligence__table-wrap mpg-table-wrap pdp-table-wrap" tabindex="0" role="region" aria-label="' +
            labelComp +
            '">'
        );
        parts.push(
          '<table class="muskle-guide-table muskle-guide-table--composition muskle-guide-table--compact muskle-product-intelligence__table mpg-table pdp-table"><thead><tr><th scope="col">' +
            h1 +
            '</th><th scope="col">' +
            h2 +
            '</th></tr></thead><tbody>'
        );
        for (var ni = 0; ni < group.nutrition_items.length; ni++) {
          var item = group.nutrition_items[ni];
          parts.push(
            '<tr><th scope="row">' +
              escapeHtml(item.label) +
              '</th><td>' +
              escapeHtml(item.value) +
              '</td></tr>'
          );
        }
        parts.push('</tbody></table></div>');
      }
      if (group.alert && group.alert.text) {
        parts.push(
          '<p class="muskle-product-intelligence__description"><strong>' +
            escapeHtml(group.alert.label || (lang === 'en' ? 'Important' : 'Belangrijk')) +
            ':</strong> ' +
            escapeHtml(group.alert.text) +
            '</p>'
        );
      }
      parts.push('</div></div>');
    }
    return parts.join('');
  }

  function getSelectedVariantId() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var fromUrl = params.get('variant');
      if (fromUrl) return normalizeVariantId(fromUrl);
    } catch (e) {}

    var checked = document.querySelector(
      'variant-picker input[type="radio"]:checked[data-variant-id], input[type="radio"][name="id"]:checked, input[name="id"][type="hidden"]'
    );
    if (checked) {
      var dv = checked.getAttribute('data-variant-id') || checked.value;
      if (dv) return normalizeVariantId(dv);
    }

    var select = document.querySelector('select[name="id"]');
    if (select && select.value) return normalizeVariantId(select.value);

    var formInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (formInput && formInput.value) return normalizeVariantId(formInput.value);

    return '';
  }

  function guideUrl(entry, lang) {
    if (!entry) return '';
    if (lang === 'en') return entry.guide_url_en || '';
    return entry.guide_url_nl || '';
  }

  function cardFields(entry, lang) {
    if (!entry || !entry.card) return null;
    var c = entry.card;
    // Card image is intentionally omitted: the product-page CTA card always
    // keeps the shared muskleproductgids.png slot (classic CARB-X logic).
    // Variant packshots belong on the guide hero / PDP gallery only.
    if (lang === 'en') {
      return {
        title: c.titleEn || '',
        body: c.bodyEn || '',
        cta: c.ctaEn || 'Read online',
        eyebrow: c.eyebrowEn || '',
        support: c.supportEn || ''
      };
    }
    return {
      title: c.titleNl || '',
      body: c.bodyNl || '',
      cta: c.ctaNl || 'Lees online',
      eyebrow: c.eyebrowNl || '',
      support: c.supportNl || ''
    };
  }

  function hideGenericChromeForVerifiedMaps() {
    var hasMap =
      document.querySelector('[data-muskle-pdp-variant-host]') ||
      document.querySelector('[data-muskle-guide-card-variant-host]');
    if (!hasMap) return;
    var sels = [
      '.muskle-benefit-row',
      '.muskle-product-hero__checklist',
      '.muskle-product-hero__media-benefits'
    ];
    for (var i = 0; i < sels.length; i++) {
      document.querySelectorAll(sels[i]).forEach(function (el) {
        el.hidden = true;
        el.setAttribute('data-muskle-hidden-by-variant-map', '1');
        el.style.setProperty('display', 'none', 'important');
      });
    }
  }

  function applyAll() {
    hideGenericChromeForVerifiedMaps();
    var hosts = document.querySelectorAll('[data-muskle-pdp-variant-host]');
    var cardHosts = document.querySelectorAll('[data-muskle-guide-card-variant-host]');
    if (!hosts.length && !cardHosts.length) return;

    var selectedId = getSelectedVariantId();

    hosts.forEach(function (host) {
      var mapEl = host.querySelector('[data-muskle-pdp-variant-map]');
      var baseEl = host.querySelector('[data-muskle-pdp-base]');
      var renderEl = host.querySelector('[data-muskle-pdp-variant-render]');
      if (!mapEl || !renderEl) return;
      var lang = (host.getAttribute('data-lang') || 'nl').toLowerCase() === 'en' ? 'en' : 'nl';
      var byId = indexMap(mapEl.textContent);
      var base = baseEl ? parseBase(baseEl.textContent) : null;
      var entry = selectedId ? byId[selectedId] : null;
      var payload = entry ? entry[lang] : base;
      var html = renderGroupsHtml(payload, lang);
      renderEl.innerHTML = html;
      host.hidden = !html;
      host.setAttribute('data-active-variant', entry ? selectedId : '');
      host.setAttribute('data-pdp-mode', entry ? 'override' : html ? 'base' : 'empty');
      var section = host.closest('[data-muskle-intelligence]');
      if (section) {
        var card = section.querySelector('.muskle-product-intelligence__card');
        if (card) card.hidden = !html;
        var heading = section.querySelector('.muskle-product-intelligence__heading-wrap');
        if (heading) heading.hidden = !html;
      }
    });

    cardHosts.forEach(function (host) {
      var mapEl = host.querySelector('[data-muskle-guide-card-map]');
      if (!mapEl) return;
      var lang = (host.getAttribute('data-lang') || 'nl').toLowerCase() === 'en' ? 'en' : 'nl';
      var byId = indexMap(mapEl.textContent);
      var entry = selectedId ? byId[selectedId] : null;
      var card = cardFields(entry, lang);
      var url = guideUrl(entry, lang);
      if (!entry || !card || !card.title || !url) {
        host.hidden = true;
        host.setAttribute('data-active-variant', '');
        return;
      }
      host.hidden = false;
      host.setAttribute('data-active-variant', selectedId);
      var titleEl = host.querySelector('[data-muskle-guide-card-title]');
      var bodyEl = host.querySelector('[data-muskle-guide-card-body]');
      var linkEl = host.querySelector('[data-muskle-guide-card-link]');
      var eyebrowEl = host.querySelector('[data-muskle-guide-card-eyebrow]');
      var supportEl = host.querySelector('[data-muskle-guide-card-support]');
      if (titleEl) titleEl.textContent = card.title;
      if (bodyEl) bodyEl.textContent = card.body || '';
      if (linkEl) {
        linkEl.remove();
      }
      if (eyebrowEl && card.eyebrow) eyebrowEl.textContent = card.eyebrow;
      if (supportEl && card.support) supportEl.textContent = card.support;
      // Do not rewrite [data-muskle-guide-card-image] from map.imageUrl —
      // shared generic Productgids graphic must stay (CARB-X parity).
      var coming = host.querySelector('[data-muskle-guide-card-coming]');
      if (coming) coming.hidden = true;
    });
  }

  function onVariantEvent(event) {
    try {
      var detail = event && event.detail;
      var resource = detail && (detail.resource || detail.variant);
      if (resource && resource.id) {
        // Update URL param awareness is enough; applyAll reads form/URL.
      }
    } catch (e) {}
    // Defer to let theme update the form id input first.
    window.setTimeout(applyAll, 0);
    window.setTimeout(applyAll, 50);
  }

  function bind() {
    document.addEventListener('variant:selected', onVariantEvent);
    document.addEventListener('variant:update', onVariantEvent);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (
        t.name === 'id' ||
        t.getAttribute('name') === 'id' ||
        t.hasAttribute('data-variant-id') ||
        (t.closest && t.closest('variant-picker'))
      ) {
        onVariantEvent(e);
      }
    });
    window.addEventListener('popstate', function () {
      window.setTimeout(applyAll, 0);
    });
    // Some themes pushState without firing popstate listeners for same-document variant URLs.
    var _push = history.pushState;
    if (typeof _push === 'function') {
      history.pushState = function () {
        var ret = _push.apply(this, arguments);
        window.setTimeout(applyAll, 0);
        return ret;
      };
    }
    var _replace = history.replaceState;
    if (typeof _replace === 'function') {
      history.replaceState = function () {
        var ret = _replace.apply(this, arguments);
        window.setTimeout(applyAll, 0);
        return ret;
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        hideGenericChromeForVerifiedMaps();
        applyAll();
      });
    } else {
      hideGenericChromeForVerifiedMaps();
      applyAll();
    }
  }

  bind();
  window.MuskleProductgidsVariant = { apply: applyAll, getSelectedVariantId: getSelectedVariantId };
})();
